import { render } from "./Specification.vue?vue&type=template&id=233e6b24&scoped=true"
import script from "./Specification.vue?vue&type=script&lang=js"
export * from "./Specification.vue?vue&type=script&lang=js"

import "./Specification.vue?vue&type=style&index=0&id=233e6b24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-233e6b24"

export default script